<template>
    <vx-expandable-card>
        <template v-slot:header> Name </template>
        <template v-slot:content>
            <vx-input
                data-test="name-input"
                ref="inputRef"
                v-model="name"
                size="lg"
                placeholder="Name"
                :error="displayFirstError(validate.name.$errors)"
            ></vx-input>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxInput } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { computed, onMounted, ref } from 'vue';
import { displayFirstError } from '~/utils/validation';

const name = defineModel({
    type: String,
    required: true,
});

const inputRef = ref();

onMounted(() => {
    inputRef.value.field.focus();
});

const validate = useVuelidate(
    {
        name: {
            required: required,
        },
    },
    computed(() => ({
        name: name.value,
    }))
);
</script>
